import React, { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { CheckCircle } from "@phosphor-icons/react";

export default function VendorSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const { refresh } = useAuth();
  const [active, setActive] = useState(null);
  const tries = useRef(0);

  useEffect(() => {
    if (!sessionId) return;
    const poll = async () => {
      try {
        const { data } = await api.get(`/vendor/confirm/${sessionId}`);
        if (data.active) { setActive(true); refresh(); return; }
      } catch {}
      if (tries.current++ < 15) setTimeout(poll, 2000); else setActive(false);
    };
    poll();
  }, [sessionId]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <main className="max-w-2xl mx-auto px-6 py-24 text-center" data-testid="vendor-success-page">
      {active ? (
        <>
          <CheckCircle size={64} weight="duotone" className="mx-auto text-signal mb-6" />
          <h1 className="font-display font-black text-4xl md:text-5xl tracking-tighter mb-4">You're a vendor.</h1>
          <p className="text-neutral-400 mb-8">Your membership is active. Start listing products now.</p>
          <Link to="/admin" className="btn-signal" data-testid="vendor-success-dashboard">Open vendor dashboard →</Link>
        </>
      ) : active === false ? (
        <>
          <h1 className="font-display font-black text-4xl mb-4">Still confirming…</h1>
          <p className="text-neutral-400 mb-8">Payment not confirmed yet. Refresh in a minute or contact support.</p>
          <Link to="/become-vendor" className="btn-outline-dark">Back</Link>
        </>
      ) : (
        <h1 className="font-display font-black text-4xl">Activating membership…</h1>
      )}
    </main>
  );
}
